import { Spin, Select } from 'antd';
import { Col } from 'reactstrap';
import '../../modules/auth/utils/login.css';

const { Option } = Select;

const SelectField = ({
  label,
  name,
  formik,
  isLoading,
  options = [],
  error,
  colSize,
  nameSelect,
  previousNameSelect,
  isName = false,
  isNameShow = false,
  onChange,
  disabled = false,
}) => {
  const value = formik.values[name] || undefined;

  return (
    <Col lg={colSize}>
      <div className="mb-3">
        <label htmlFor={name} className="form-label label">{label}</label>

        <Select
          id={name}
          value={value}
          showSearch
          allowClear
          size="large"
          loading={isLoading}
          notFoundContent={isLoading ? <Spin size="small" /> : "Aucune donnée"}
          placeholder={
            disabled
              ? `Veuillez d'abord choisir ${previousNameSelect}`
              : nameSelect ? `Choisir ${nameSelect}` : ""
          }
          optionFilterProp="children"
          onChange={(val, option) => {
            formik.setFieldValue(name, val || "");
            if (onChange) onChange(val, option);
          }}
          onBlur={() => formik.setFieldTouched(name, true)}
          disabled={disabled}
          style={{ width: '100%', height: '44px' }}
          filterOption={(input, option) =>
            String(option.children).toLowerCase().includes(input.toLowerCase())
          }
        >
          {options.map((option) => (
            <Option
              key={option.id || option.value || option.label}
              value={isName ? option.businessName : option.id || option.label}
            >
              {isNameShow
                ? option.name
                : option.businessName || option.label || "-"}
            </Option>
          ))}
        </Select>

        {formik.touched[name] && error && (
          <div className="text-danger">{error}</div>
        )}
      </div>
    </Col>
  );
};

export default SelectField;